var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicket = function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#131635",
    d: "M14.276 6.715a.39.39 0 0 0 .39-.391V4.439A1.44 1.44 0 0 0 13.23 3H2.77a1.44 1.44 0 0 0-1.436 1.439v1.885a.39.39 0 0 0 .39.391 1.285 1.285 0 0 1 0 2.57.39.39 0 0 0-.39.391v1.885A1.44 1.44 0 0 0 2.77 13h10.46a1.44 1.44 0 0 0 1.437-1.439V9.676a.39.39 0 0 0-.39-.391 1.285 1.285 0 0 1 0-2.57m-3.493 1L9.675 8.798l.258 1.506a.392.392 0 0 1-.38.479h-.001a.4.4 0 0 1-.182-.045L8 10.016l-1.37.721a.39.39 0 0 1-.566-.412l.261-1.528-1.108-1.081a.392.392 0 0 1 .217-.667l1.531-.223.685-1.39a.39.39 0 0 1 .7 0l.685 1.39 1.532.223a.39.39 0 0 1 .216.667"
  })));
};
export default SvgTicket;